import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import eventResourceModel from "src/models/event/models/resource"
import collection from "src/hocs/collection"

const configurator = ({ eventUuid }) => ({
  engine: entity,
  to: `eventResources`,
  model: eventResourceModel(eventUuid),
  query: {
    limit: -1,
    orderBy: `name asc`,
  },
})

export default config =>
  compose(
    /* Using props' flow allows to extend basic configuration */
    collection(props => ({
      ...configurator(props),
      ...(isFunction(config) ? config(props) : config),
    })),
  )
